var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('Stack',{staticClass:"form",attrs:{"space-unit":"0"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }